<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <plan-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import PlanCrud from "./PlanCrud";
    export default {
        name: "PlanManagementPage",
        components: { PlanCrud }
    }
</script>
